import React from 'react';
import { string } from 'prop-types';

const CargoSealColor = ({
  className = '',
  color = '#14803c',
}) => (
  <svg className={className} width="1.4rem" height="1.4rem" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M1.16675 1.16663H4.08341L3.03756 2.21248L3.74171 2.91663H5.83341L4.78756 3.96248L5.65988 4.8348C5.676 4.8339 5.69223 4.83345 5.70857 4.83345H8.77107C9.0117 4.83345 9.23045 4.9297 9.38795 5.0872L13.3254 9.0247C13.4829 9.1822 13.5836 9.40532 13.5836 9.64595C13.5836 9.88657 13.4873 10.1053 13.3254 10.2628L10.2629 13.3253C10.1054 13.4872 9.8867 13.5834 9.64607 13.5834C9.40545 13.5834 9.1867 13.4872 9.0292 13.3297L5.0917 9.3922C4.92982 9.23032 4.83357 9.01157 4.83357 8.77095V5.70845C4.83357 5.69211 4.83402 5.67588 4.83492 5.65976L3.9626 4.78744L2.91675 5.83329V3.74158L2.2126 3.03744L1.16675 4.08329V1.16663ZM9.83772 7.53783C9.73187 7.43199 9.56027 7.43199 9.45442 7.53783L7.53795 9.4543C7.43211 9.56015 7.43211 9.73175 7.53795 9.8376L9.45442 11.7541C9.56027 11.8599 9.73187 11.8599 9.83772 11.7541L11.7542 9.8376C11.86 9.73175 11.86 9.56015 11.7542 9.4543L9.83772 7.53783ZM6.11269 6.99996C6.11269 6.50987 6.50999 6.11257 7.00008 6.11257C7.49017 6.11257 7.88747 6.50987 7.88747 6.99996C7.88747 7.49005 7.49017 7.88735 7.00008 7.88735C6.50999 7.88735 6.11269 7.49005 6.11269 6.99996Z" fill={color} />
  </svg>
);

CargoSealColor.propTypes = {
  className: string,
  color: string,
};

export default CargoSealColor;
